import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import DistributerForm from "../../components/NewDistributer/DistributerForm";

function NewDistributer() {
    const history = useHistory();
    return (
        <>
            <Container fluid className="distributerSection">
                <Row>
                    <Col
                        md={12}
                        className="d-flex justify-content-start  align-items-center h-100 mt-5"
                    >
                        <h1 className="mt-5  text-uppercase distributerSection__heading">
                            Lets Invite Your Favorite Distributor
                        </h1>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="mt-5">
                <Row>
                    <Col md={12}>
                        {/* <Button
                            size="slg"
                            className="mt-n5 btn text-dark border bg-white"
                            onClick={() => {
                                history.push("/");
                            }}
                        >
                            Go Back
                        </Button> */}
                        <h1 className="heading mt-3">BECOME A DISTRIBUTOR</h1>
                        <p>
                            Thank you for your interest in becoming a
                            distributor. To help us learn and understand more
                            about your business, and how we can work together,
                            please fill out form for us to review and discuss.
                        </p>
                        {/* <ul className="ml-4">
                            <li>
                                Initial purchase of $1500 (domestic) or $2500
                                (international) of Where to Buy goods
                            </li>
                            <li>
                                Must purchase $2,000 of goods in a given
                                12-month span to keep account and discount
                                active
                            </li>
                        </ul> */}
                    </Col>
                </Row>
            </Container>

            {/* distributer form  */}
            <DistributerForm />
        </>
    );
}

export default NewDistributer;
